import './Menu.css'
import React, { useState } from 'react'
import Sidebar from '../../Components/SideBar/index'
import ScrollToTop from '../../Components/ScrollToTop'
import Index2 from '../../Components/Navbar2/index2'
import Footer from '../../Components/Footer/Footer'
import InfoSection3 from '../../Components/Infosection3/Index3'
import { homeObjOne3 } from '../../Components/Infosection3/Data3'

const MenuVie = () => {
  const [isOpen, setIsOpen] = useState(false)
                        
  const toggle = () => {
  setIsOpen(!isOpen)
  }
  return (
    <>
      <ScrollToTop />
      <div className='HeroContainer_menu'>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='Hero_menu'>
          <Index2 toggle={toggle}/>
        </div>
      </div>
      <InfoSection3 {...homeObjOne3}/>
      <div className='menu_con'>
        <div className='menu_title'>
          Vår Meny
        </div>
         <div className='pris'>
          För mer info kontakta gärna 
          <br />
          076 413 08 53
          <br />
          cateringbyprestig@gmail.com
        </div>
      </div>
      <br />
      <br /><br />
      <div className='menu'>
        <div className='menu_pic'>
          <div className='grid-container'>
                  <div className='card_con'>
                    <div className='wrapper'>
                      <br /><br />
                        <div className='card_area'>
                          <div className='card'>
                            <div className='meny_title'>
                              KALLA VIETNAMESISKA DELIKATESSER
                            </div><br /><br />
                            <div className='menu_mat'>
                              Goi Bo – vietnamesisk nötköttssallad med lime, mynta, koriander & chili.
                              <br /><br />
                                Goi Ga – vietnamesisk kycklingsallad med morot, kål, mynta & lime.
                                <br /><br />
                                Goi Cuon – färska rispappersrullar med räkor, kyckling, örter & grönsaker.
                                <br /><br />
                                Vietnamesisk gurksallad med chili, lime & sesam.
                                <br /><br />
                                Picklade morötter & daikon.
                                <br /><br />
                                Mango- & örtsallad med färsk koriander & mynta.
                                <br /><br />
                                Edamame med chili & havssalt.
                            </div>
                            </div>
                            <div className='card'>
                              <div className='meny_title'>
                                VIETNAMESISKA SMAKBITAR
                              </div><br /><br />
                              <div className='menu_mat'>
                                Cha Gio – krispiga vietnamesiska vårrullar med färs & grönsaker.
                                <br /><br />
                                Vegetariska vårrullar med svamp & grönsaker.
                                <br /><br />
                                Crispy chicken bites med chili & lime.
                                <br /><br />
                                Räkor i krispig panering med sweet chili & lime.
                              </div> 
                            </div>              
                            <div className='card'>
                              <div className='meny_title'>
                                VARMA VIETNAMESISKA SPECIALITETER
                              </div><br /><br />
                            <div className='menu_mat'>
                             
                            Lemongrass Chicken - 
                            Marinerad kyckling med citrongräs, vitlök, chili & lime.
                            <br /><br />
                            Vietnamese Beef - 
                            Wokat nötkött med vitlök, ingefära, chili & färska örter.
                            <br /><br />
                            Tamarindräkor - 
                            Wokade räkor med tamarind, chili, lime & färska örter.
                            <br /><br />
                            Wokade risnudlar - 
                            Risnudlar med grönsaker, ägg, färska örter & vietnamesisk soja.
                            </div>
                            </div>
                            <div className='card'>
                            <div className='meny_title'>
                              RIS & TILLBEHÖR

                                </div><br /><br />
                                <div className='menu_mat'>
                                  Jasminris med färska örter.
                                  <br /><br />
                                    Stekt ris med grönsaker & ägg.
                                    <br /><br />
                                    Wokade grönsaker med ingefära & vitlök.
                                    <br /><br />
                                    Krispig vitlök.
                                    <br /><br />
                                    Rostade jordnötter.
                                    <br /><br />
                                    Färsk koriander, mynta & thaibasilika.
                                </div>
                                </div>
                                <div className='card'>
                              <div className='meny_title'>
                                   SÅSER & DRESSINGAR
                                </div><br /><br />
                                <div className='menu_mat'>
                                    Nuoc Cham – klassisk vietnamesisk lime- & fisksås.
                                    <br /><br />
                                    Sweet chili.
                                    <br /><br />
                                    Hoisinsås.
                                    <br /><br />
                                    Sriracha.
                                    <br /><br />
                                    Lime- & chilidressing.
                                    <br /><br />
                                    Jordnötssås.
                                    <br /><br />
                                </div>
                                </div>
                                <div className='card'>
                              <div className='meny_title'>
                                VIETNAMESISKA DESSERTER
                        </div><br /><br />
                        <div className='menu_mat'>
                         Mango Sticky Rice med kokos.
                         <br /><br />
                        Kokospannacotta med passionsfrukt.
                        <br /><br />
                        Vietnamesiskt kaffe med kondenserad mjölk som dessertkräm.
                        <br /><br />
                        Friterad banan med kokos & honung.
                        <br /><br />
                        Färsk mango, ananas & passionsfrukt.
                        </div>
                    </div>
                  </div>             
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  )
}

export default MenuVie